import { ChangeDetectionStrategy, Component, Inject, inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { ClientAccountFacade } from '@galabid/gb-dashboard/client-account/data-access'
import { ClientAccountActions } from '@galabid/gb-dashboard/client-account/data-access'

@Component({
  selector: 'gb-client-accounts-preview',
  templateUrl: './gb-client-accounts-preview.component.html',
  styleUrl: './gb-client-accounts-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbClientAccountsPreviewComponent {
  get clientAccounts(): { name: string; uuid: string }[] {
    return this.data.clientAccounts
  }

  private clientAccountFacade = inject(ClientAccountFacade)

  constructor(@Inject(MAT_DIALOG_DATA) private data: { clientAccounts: Array<{ name: string; uuid: string }> }) {}

  goToClientAccount(uuid: string, event: MouseEvent) {
    this.clientAccountFacade.dispatch(ClientAccountActions.goToClientAccount({ uuid, newTab: event.metaKey }))
  }
}
